import "../../../components/welcomeScreen/welcomeWizard.scss";

import { List } from "immutable";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import FormCheckbox from "../../../components/form/FormCheckbox";
import ModalCheckboxGrid from "../../../components/modal/ModalCheckboxGrid";
import ModalDescription from "../../../components/modal/ModalDescription";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import { referenceOperations } from "../../../modules/definition/references";
import { typeOperations } from "../../../modules/definition/types";
import preprocessorQuery from "../../../utils/preprocessorQuery";
import settingsSelectors from "../../settingsModal/selectors";

const isIos = preprocessorQuery.isIos();

const runOnIncludeDateTypesChange = (onIncludeDataTypesChange, value, otherTypes) => {
  onIncludeDataTypesChange ? onIncludeDataTypesChange(value ? otherTypes : List()) : null;
};

const updateIncludeDateTypes = (
  props,
  filteredEventTypes,
  otherTypes,
  setIncludeDataTypes,
  eventToEventReferences,
  personToPersonReferences,
  value
) => {
  const typeAction = typeOperations.changeEnabled(
    filteredEventTypes.concat(otherTypes).map(type => type.id),
    value
  );
  const eventToEventAction = referenceOperations.changeEnabled(
    eventToEventReferences.map(ref => ref.id),
    value
  );
  const personToPersonAction = referenceOperations.changeEnabled(
    personToPersonReferences.map(ref => ref.id),
    value
  );

  props.dispatchLocal([typeAction, eventToEventAction, personToPersonAction]);

  runOnIncludeDateTypesChange(props.onIncludeDataTypesChange, value, otherTypes);
  setIncludeDataTypes(value);
};

const renderDescription = (
  props,
  filteredEventTypes,
  otherTypes,
  includeDataTypes,
  setIncludeDataTypes,
  eventToEventReferences,
  personToPersonReferences
) => {
  const onIncludeDataTypesChangeInner = value => {
    updateIncludeDateTypes(
      props,
      filteredEventTypes,
      otherTypes,
      setIncludeDataTypes,
      eventToEventReferences,
      personToPersonReferences,
      value
    );
  };

  return (
    <ModalGroup>
      <ModalRow key="description">
        <ModalDescription>
          <span>
            Aeon Timeline now supports multiple event types, other types and event-to-event/entity-to-entity
            relationships. You can enable these new data types to build a more complete picture of your data.
          </span>
        </ModalDescription>
      </ModalRow>
      {filteredEventTypes.size || otherTypes.size || eventToEventReferences.size || personToPersonReferences.size ? (
        <ModalRow key="includeDataTypes">
          <ModalField>
            <div className="fullWidthOptions">
              <ModalCheckboxGrid>
                <FormCheckbox
                  label={`Add recommended event, entity, and relationship types from the ${props.templateName} template`}
                  checkboxState={includeDataTypes}
                  onChange={onIncludeDataTypesChangeInner}
                />
              </ModalCheckboxGrid>
            </div>
          </ModalField>
        </ModalRow>
      ) : null}
      {isIos ? <br /> : null}
      <ModalRow>
        <ModalDescription>
          <span>
            You can enable or disable event and relationship types at any time from the timeline&apos;s settings.
          </span>
        </ModalDescription>
      </ModalRow>
    </ModalGroup>
  );
};

const DefaultsPage = props => {
  const eventTypes = settingsSelectors.eventTypesFromAllTypes(props.types);
  const personTypes = settingsSelectors.personTypesFromAllTypes(props.types);
  const filteredEventTypes = eventTypes.filter(type => type.id != props.defaultSequenceType);
  const otherTypesExcludingNarrativeFolder = settingsSelectors.otherTypesFromAllTypesExcludingNarrativeFolder(
    props.types
  );
  const eventToPersonReferences = settingsSelectors.eventToPersonReferences(props.references, eventTypes, personTypes);
  const eventToEventReferences = settingsSelectors
    .eventToEventReferences(props.references, eventTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));
  const personToPersonReferences = settingsSelectors
    .personToPersonReferences(props.references, personTypes)
    .filter(ref => !eventToPersonReferences.find(ref2 => ref2.id === ref.id));

  const [includeDataTypes, setIncludeDataTypes] = useState(false);

  // Equal to didMount
  useEffect(() => {
    updateIncludeDateTypes(
      props,
      filteredEventTypes,
      otherTypesExcludingNarrativeFolder,
      setIncludeDataTypes,
      eventToEventReferences,
      personToPersonReferences,
      props.includeDataTypes
    );
  }, []);

  return [
    <ModalGroup key="content">
      {renderDescription(
        props,
        filteredEventTypes,
        otherTypesExcludingNarrativeFolder,
        includeDataTypes,
        setIncludeDataTypes,
        eventToEventReferences,
        personToPersonReferences
      )}
    </ModalGroup>
  ];
};

DefaultsPage.propTypes = {
  types: ImmutablePropTypes.list.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  properties: ImmutablePropTypes.list.isRequired,
  templateName: PropTypes.string.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  defaultSequenceType: PropTypes.string,
  onIncludeDataTypesChange: PropTypes.func,
  includeDataTypes: PropTypes.bool
};

renderDescription.propTypes = DefaultsPage.propTypes;

export default DefaultsPage;
